// Web Locks serializa entre abas da mesma origem; sem ela, roda direto.
export const withCrossTabLock = <T>(
  name: string,
  fn: () => T | Promise<T>,
): Promise<T> =>
  typeof navigator !== 'undefined' && navigator.locks
    ? navigator.locks.request(name, fn)
    : Promise.resolve(fn());
